/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * VisitTimeWindowDtoBase
 * auto generated base class for the model VisitTimeWindowDtoModel.
 */
export const VisitTimeWindowDtoModelBase = ModelBase
  .named('VisitTimeWindowDto')
  .props({
    __typename: types.optional(types.literal("VisitTimeWindowDto"), "VisitTimeWindowDto"),
    id: types.identifier,
    startTime: types.union(types.undefined, types.null, types.string),
    endTime: types.union(types.undefined, types.null, types.string),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class VisitTimeWindowDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get startTime() { return this.__attr(`startTime`) }
  get endTime() { return this.__attr(`endTime`) }
}
export function selectFromVisitTimeWindowDto() {
  return new VisitTimeWindowDtoModelSelector()
}

export const visitTimeWindowDtoModelPrimitives = selectFromVisitTimeWindowDto().startTime.endTime
